import routeTypes from './route-types'

const FlexiquoteModuleView = () => import(/* webpackChunkName: "superadmin-flexiquotemodule-chunk" */ './FlexiquoteModuleView.vue')
const FlexiquoteModuleDetail = () => import(/* webpackChunkName: "superadmin-flexiquotemodule-chunk" */ './FlexiquoteModuleDetail.vue')
const FlexiquoteModuleListView = () => import(/* webpackChunkName: "superadmin-flexiquotemodule-chunk" */ './FlexiquoteModuleListView.vue')

export default [
  {
    path: routeTypes.FlexiquoteModuleListView.path,
    name: routeTypes.FlexiquoteModuleListView.name,
    component: FlexiquoteModuleListView,
    meta: {
      title: 'Manage FlexiQuote Modules',
      access: {
        isAdd: true
      }
    }

  },
  {
    path: routeTypes.FlexiquoteModuleView.path,
    name: routeTypes.FlexiquoteModuleView.name,
    component: FlexiquoteModuleView,
    props: (route) => ({
      isNew: route.meta.isNew,
      returnUrl: route.query.returnUrl || route.meta.returnUrl
    }),
    meta: {
      title: 'FlexiQuote Module'
    },
    children: [
      {
        path: ':moduleId',
        name: routeTypes.FlexiquoteModuleDetail.name,
        component: FlexiquoteModuleDetail,
        meta: {
          title: '',
          access: {
            isEdit: true
          }
        },
        props: true
      }
    ]
  }
]
